import get from 'lodash/get'

/**
 * hasFeature()
 *
 * @param {object} features - feature set configuration
 * @param {string} feature - required feature (using `semmicolon:seperated:form`)
 */
export const hasFeature = (features, feature) => !!get(features, feature.replace(/:/g, '.'))
